var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left",
    clipPath: "url(#clip0_1050_30784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.66115 2.06646V1.03119C9.66115 0.941456 9.55803 0.891902 9.48839 0.946813L3.45088 5.66244C3.39959 5.70233 3.35808 5.75341 3.32953 5.81179C3.30098 5.87016 3.28613 5.93429 3.28613 5.99927C3.28613 6.06425 3.30098 6.12838 3.32953 6.18675C3.35808 6.24512 3.39959 6.29621 3.45088 6.3361L9.48839 11.0517C9.55937 11.1066 9.66115 11.0571 9.66115 10.9673V9.93208C9.66115 9.86646 9.63035 9.80351 9.57946 9.76333L4.75803 5.99994L9.57946 2.23521C9.63035 2.19503 9.66115 2.13208 9.66115 2.06646Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_30784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.821777 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretLeft);
export default __webpack_public_path__ + "static/media/icon-caret-left.d730bf4a660504950f8b2162476ea2f2.svg";
export { ForwardRef as ReactComponent };